export function isHomepagePath(currentPath, basePath = '') {
  const pathOnly = currentPath.split('?')[0];
  return pathOnly === basePath + '/';
}

export function findTagBySlug(tags, slug) {
  return tags.find((tag) => typeof tag.slug === 'function' && tag.slug() === slug);
}

export function shouldShowChallenge(tags) {
  return Boolean(findTagBySlug(tags, 'quarterly-challenge'));
}
